import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../AuthProvider";
import { get_user } from "../API/user";
import { isAdminRole } from "../admin/resolvePostAuthPath";

interface Props {
  children: React.ReactNode;
}

const AdminProtectedRoute: React.FC<Props> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [role, setRole] = useState<string | null>(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let cancelled = false;

    if (loading) {
      return;
    }

    if (!user) {
      setRole(null);
      setChecking(false);
      return;
    }

    setChecking(true);
    get_user()
      .then((response) => {
        if (!cancelled) {
          setRole(response.data?.role ?? "founder");
        }
      })
      .catch(() => {
        if (!cancelled) {
          setRole("founder");
        }
      })
      .finally(() => {
        if (!cancelled) {
          setChecking(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [user, loading]);

  if (loading || checking) return null;

  if (!user) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (!isAdminRole(role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AdminProtectedRoute;
